<template>
    <div class="row" v-if="hasProducts">
        <div class="featured-products-title-container">
            <h3>Destaques</h3>
        </div>
        <div class="destaques_alinhamento">
            <c-home-product
                v-for="product in productsList"
                :key="product.id"
                :productId="product.id"
                :productName="product.name"
                :productRef="product.ref"
                :productImage="product.image"
                :productLink="product.link"
                :productPrice="product.price"
                :productPromotionalPrice="product.promotional_price"
                :productQuantityPackaging="product.quantity_packaging"
                :productHavePromotion="product.have_promotion"
                :loading="loading"
                :isCustomerTypeSale="isCustomerTypeSale"
                />
        </div>
        <div class="featured-products-see-all-container">
            <div class="featured-products-see-all">
                <a :href="catalogFeatured">
                    Ver Todos os Itens <i class="fas fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</template>
<script>

export default {
	props: [
        'catalogFeatured',
        'isCustomerTypeSale',
    ],
	data() { 
        return {
            loading: true,
            productsList: []
        } 
    },
    computed: {
        hasProducts: function() {
            return this.productsList.length > 0
        }
    },
	methods: {
        fetchProducts() {
            const vm = this
            this.axios.get(API_URL + '/home/featured-products')
				.then(({ data }) =>
				{
                    data.products.forEach((p, i) => {
                        vm.productsList.splice(i, 1, p)
                    })
                    vm.loading = false
				}
			)
        }
    },
    mounted() {
        this.fetchProducts()
    }
}
</script>